import { useQuery } from '@apollo/client';
import React from 'react';
import { useHistory } from 'react-router';
import { RENDER_QUEUES } from '../../api/GraphQL';
import Panel from '../ui/Panel';
import Row from '../ui/Row';
import Table from '../ui/Table';

function List() {
  const { loading, data } = useQuery(RENDER_QUEUES);
  const history = useHistory();

  return (
    <Row>
      <Panel title={'Render queue list'}>
        {loading && <div>Loading</div>}
        {!loading && data && (
          <Table
            data={data.renderQueues}
            columns={[
              { Header: 'ID', accessor: '_id' },
              { Header: 'Name', accessor: 'name' },
              {
                Header: 'Teams',
                accessor: (item) => {
                  return item.teams?.map((t) => t?.name).join(', ');
                },
              },
            ]}
            onRowSelect={(item) => {
              history.push('/render-queues/' + item._id);
            }}
          />
        )}
      </Panel>
    </Row>
  );
}

export default List;
